module.exports = __webpack_public_path__ + "static/media/fifa.0be7d65d.jpg";